import { Avatar } from 'antd';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import React from 'react';

import * as S from './styles';

type Props = React.PropsWithChildren;

export const OrbitingBackground: React.FC<Props> = ({ children }) => {
  const { xs } = useBreakpoint();
  return xs ? (
    <>{children}</>
  ) : (
    <>
      <S.Wrap>
        <S.DotOrbit $diameter={825} $duration="200s" $direction={-1}>
          <S.Dot $diameter={825} $initialAngle={90}>
            <Avatar
              shape="circle"
              src="/images/orbiting-background/gal_1_90.png"
            />
          </S.Dot>
        </S.DotOrbit>

        <S.DotOrbit $diameter={1008} $duration="240s" $direction={1}>
          <S.Dot $diameter={1008} $initialAngle={315}>
            <Avatar
              shape="circle"
              src="/images/orbiting-background/gal_2_315.png"
            />
          </S.Dot>
          <S.Dot $diameter={1008} $initialAngle={225}>
            <Avatar
              shape="circle"
              src="/images/orbiting-background/dude_2_225.png"
            />
          </S.Dot>
        </S.DotOrbit>

        <S.DotOrbit $diameter={1198} $duration="380s" $direction={-1}>
          <S.Dot $diameter={1198} $initialAngle={45}>
            <Avatar
              shape="circle"
              src="/images/orbiting-background/dude_3_45.png"
            />
          </S.Dot>
          <S.Dot $diameter={1198} $initialAngle={135}>
            <Avatar
              shape="circle"
              src="/images/orbiting-background/dude_3_135.png"
            />
          </S.Dot>
          <S.Dot $diameter={1198} $initialAngle={280}>
            <Avatar
              shape="circle"
              src="/images/orbiting-background/gal_3_280.png"
            />
          </S.Dot>
        </S.DotOrbit>
      </S.Wrap>
      {children}
    </>
  );
};
